/**
 * convert a dictionary into a string
 */
export const writeDictionary = (
  dict: Record<string, unknown>,
  writer: (value: unknown, key: string) => string
): string => {
  return Object.entries(dict)
    .map(([key, value]) => writer(value, key))
    .join('\n');
};
